import { searchEntities } from '../../store/selectors/search';

export const selectSpecifications = state => searchEntities(state, 'specifications', ['title', 'description']);
